export async function patchUser(httpClient, authInstance, fields) {
  const data = await httpClient.patch('/v3/fe/web-users', fields);
  if (data) {
    authInstance.setUser(data);
  } else {
    await authInstance.fetchUser();
  }
}
